import React from 'react'
import Layout from './Layout'
import DailyInfo from '../components/widgets/DailyInfo'
import Dynamiclead from '../components/widgets/Dynamiclead'
import Articles from '../components/widgets/Articles'
import SimpleTitle from '../components/boxes/titles/SimpleTitle'
import CarsTitle from '../components/boxes/titles/CarsTitle'
import HousingTitle from '../components/boxes/titles/HousingTitle'
import Exchange from '../components/widgets/Exchange'
import NewsFeed from '../components/widgets/NewsFeed'
import PromoLink from '../components/widgets/Tip/PromoLink'
import Video from '../components/widgets/Video'
import Services from '../components/widgets/Services'
import MyFinance from '../components/widgets/MyFinance'
import { DefaultEmail } from '../components/widgets/Email'
import ForecastWeather from '../components/widgets/Weather/ForecastWeather'
import DailyDiscounts from '../components/widgets/DailyDiscounts'
import Jobs from '../components/widgets/Jobs'
import TvProgram from '../components/widgets/TvProgram'
import Horoscopes from '../components/widgets/Horoscopes'
import HoroscopesTip from '../components/widgets/Tip/HoroscopesTip'
import Futro from '../components/widgets/Futro'
import FlightTickets from '../components/widgets/FlightTickets'
import Ecommerce from '../components/widgets/Ecommerce'
import TipOfTheDay from '../components/widgets/TipOfTheDay'
import NativeAppPromo from '../components/widgets/NativeAppPromo'
import { LAYOUT_SECTIONS, WIDGETS } from '../constants'

class Homepage extends Layout {
  getDynamicWidgets () {
    const {
      widgets,
      containers: {
        inbox
      }
    } = this.state

    return Object.assign({}, super.getDynamicWidgets(), {
      [WIDGETS.HOMEPAGE.DAILY_INFO]: <DailyInfo widgets={widgets}/>,
      [WIDGETS.HOMEPAGE.DYNAMIC_LEAD]: <Dynamiclead widget={widgets.dynamiclead} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.NEWS]: <Articles widget={widgets.news} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.TIP_OF_THE_DAY]: <TipOfTheDay widget={widgets.tipoftheday}/>,
      [WIDGETS.HOMEPAGE.SPORT]: <Articles widget={widgets.sport} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.WOMAN]: <Articles widget={widgets.woman} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.VIDEO]: <Video widget={widgets.video}/>,
      [WIDGETS.HOMEPAGE.MAGAZINE]: <Articles widget={widgets.magazine} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.FINANCE]: <Articles widget={widgets.finance} titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.NEWS_FEED]: <NewsFeed widget={widgets.newsfeed}/>,
      [WIDGETS.HOMEPAGE.EMAIL]: (<DefaultEmail widget={widgets.email} container={inbox}/>),
      [WIDGETS.HOMEPAGE.PROMO_LINK]: <PromoLink widget={widgets.promolink}/>,
      [WIDGETS.HOMEPAGE.SERVICES]: <Services widget={widgets.services}/>,
      [WIDGETS.HOMEPAGE.WEATHER]: <ForecastWeather widget={widgets.weather}/>,
      [WIDGETS.HOMEPAGE.DAILY_DISCOUNTS]: <DailyDiscounts widget={widgets.dailydiscounts}/>,
      [WIDGETS.HOMEPAGE.JOBS]: <Jobs widget={widgets.jobs}/>,
      [WIDGETS.HOMEPAGE.EXCHANGE]: <Exchange widget={widgets.exchange}/>,
      [WIDGETS.HOMEPAGE.FLIGHT_TICKETS]: <FlightTickets widget={widgets.flighttickets}/>,
      [WIDGETS.HOMEPAGE.MY_FINANCE]: <MyFinance widget={widgets.myfinance}/>,
      [WIDGETS.HOMEPAGE.ECOMMERCE]: <Ecommerce widget={widgets.ecommerce}/>,
      [WIDGETS.HOMEPAGE.TV_PROGRAM]: <TvProgram widget={widgets.tvprogram}/>,
      [WIDGETS.HOMEPAGE.GAMES]: <Articles widget={widgets.games} vertical titleComponent={SimpleTitle}/>,
      [WIDGETS.HOMEPAGE.HOROSCOPES]: <Horoscopes widget={widgets.horoscopes}/>,
      [WIDGETS.HOMEPAGE.HOROSCOPES_TIP]: <HoroscopesTip widget={widgets.horoscopestip}/>,
      [WIDGETS.HOMEPAGE.CARS]: <Articles widget={widgets.cars} vertical titleComponent={CarsTitle}/>,
      [WIDGETS.HOMEPAGE.HOUSING]: <Articles widget={widgets.housing} vertical titleComponent={HousingTitle}/>,
      [WIDGETS.HOMEPAGE.FUTRO]: <Futro widget={widgets.futro}/>,
      [WIDGETS.HOMEPAGE.NATIVE_APP_PROMO]: <NativeAppPromo widget={widgets.nativeapppromo}/>
    })
  }

  getDesktopWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.LEADERBOARD
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH,
        WIDGETS.COMMON.EMAIL_LINK,
        WIDGETS.COMMON.HOT_SEARCH
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [
        WIDGETS.HOMEPAGE.DAILY_INFO
      ],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.DYNAMIC_LEAD,
        WIDGETS.HOMEPAGE.NEWS,
        WIDGETS.HOMEPAGE.TIP_OF_THE_DAY,
        WIDGETS.HOMEPAGE.VIDEO,
        WIDGETS.HOMEPAGE.WOMAN,
        WIDGETS.HOMEPAGE.SPORT,
        WIDGETS.HOMEPAGE.FINANCE,
        WIDGETS.HOMEPAGE.NEWS_FEED
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [
        WIDGETS.HOMEPAGE.EMAIL,
        WIDGETS.HOMEPAGE.PROMO_LINK,
        WIDGETS.HOMEPAGE.SERVICES,
        WIDGETS.COMMON.RIGHT_BANNER,
        WIDGETS.HOMEPAGE.WEATHER,
        WIDGETS.HOMEPAGE.DAILY_DISCOUNTS,
        WIDGETS.HOMEPAGE.JOBS,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGETS.HOMEPAGE.FLIGHT_TICKETS,
        WIDGETS.HOMEPAGE.MY_FINANCE,
        WIDGETS.HOMEPAGE.ECOMMERCE,
        WIDGETS.HOMEPAGE.TV_PROGRAM,
        WIDGETS.HOMEPAGE.GAMES,
        WIDGETS.HOMEPAGE.HOROSCOPES,
        WIDGETS.HOMEPAGE.HOROSCOPES_TIP,
        WIDGETS.HOMEPAGE.HOUSING,
        WIDGETS.HOMEPAGE.CARS,
        WIDGETS.COMMON.HALF_PAGE
      ],
      [LAYOUT_SECTIONS.BOTTOM]: [
        WIDGETS.HOMEPAGE.FUTRO
      ],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: []
    }
  }

  getTabletWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.STRIP
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.EMAIL,
        WIDGETS.HOMEPAGE.PROMO_LINK,
        WIDGETS.HOMEPAGE.DAILY_INFO,
        WIDGETS.HOMEPAGE.DYNAMIC_LEAD,
        WIDGETS.COMMON.SMART_ADVERT_1,
        WIDGETS.HOMEPAGE.NEWS,
        WIDGETS.HOMEPAGE.DAILY_DISCOUNTS,
        WIDGETS.HOMEPAGE.VIDEO,
        WIDGETS.HOMEPAGE.WOMAN,
        WIDGETS.COMMON.SMART_ADVERT_2,
        WIDGETS.HOMEPAGE.SPORT,
        WIDGETS.HOMEPAGE.FINANCE,
        WIDGETS.HOMEPAGE.WEATHER,
        WIDGETS.HOMEPAGE.MY_FINANCE,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGETS.HOMEPAGE.FLIGHT_TICKETS,
        WIDGETS.HOMEPAGE.HOUSING,
        WIDGETS.HOMEPAGE.CARS,
        WIDGETS.HOMEPAGE.TV_PROGRAM,
        WIDGETS.HOMEPAGE.JOBS,
        WIDGETS.COMMON.SMART_ADVERT_3
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [],
      [LAYOUT_SECTIONS.BOTTOM]: [
        WIDGETS.HOMEPAGE.FUTRO
      ],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: []
    }
  }

  getMobileWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.STRIP
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.DAILY_INFO,
        WIDGETS.HOMEPAGE.EMAIL,
        WIDGETS.HOMEPAGE.PROMO_LINK,
        WIDGETS.HOMEPAGE.DYNAMIC_LEAD,
        WIDGETS.COMMON.SMART_ADVERT_1,
        WIDGETS.HOMEPAGE.NEWS,
        WIDGETS.HOMEPAGE.DAILY_DISCOUNTS,
        WIDGETS.HOMEPAGE.VIDEO,
        WIDGETS.HOMEPAGE.WOMAN,
        WIDGETS.COMMON.SMART_ADVERT_2,
        WIDGETS.HOMEPAGE.SPORT,
        WIDGETS.HOMEPAGE.MAGAZINE,
        WIDGETS.HOMEPAGE.FINANCE,
        WIDGETS.HOMEPAGE.WEATHER,
        WIDGETS.HOMEPAGE.MY_FINANCE,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGETS.HOMEPAGE.FLIGHT_TICKETS,
        WIDGETS.HOMEPAGE.HOUSING,
        WIDGETS.HOMEPAGE.CARS,
        WIDGETS.HOMEPAGE.TV_PROGRAM,
        WIDGETS.HOMEPAGE.JOBS,
        WIDGETS.COMMON.SMART_ADVERT_3
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [],
      [LAYOUT_SECTIONS.BOTTOM]: [
        WIDGETS.HOMEPAGE.FUTRO
      ],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: []
    }
  }
}

export default Homepage
